import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  sourceCategories: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_SOURCE_CATEGORIES_BUSY: (state, payload) => {
    state.sourceCategories.isBusy = payload;
  },
  LOAD_SOURCE_CATEGORIES_SUCCESS: (state, payload) => {
    state.sourceCategories.data = payload.data;
    state.sourceCategories.error = null;
  },
  LOAD_SOURCE_CATEGORIES_FAIL: (state, payload) => {
    state.sourceCategories.data = null;
    state.sourceCategories.error = payload;
  }
};

const actions = {
  getSourceCategories: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_SOURCE_CATEGORIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/source_categories`, config)
      .then(response => {
        commit('LOAD_SOURCE_CATEGORIES_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_SOURCE_CATEGORIES_FAIL', error)
      })
      .finally(() => commit('LOAD_SOURCE_CATEGORIES_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};